<template>
  <div class="course-detail-section-card service-highlights">
    <!-- 装饰条 -->
    <template v-if="showDecoration">
      <div class="link-rope link-top-top left">
        <div class="rope" />
      </div>
      <div class="link-rope link-top-top right">
        <div class="rope" />
      </div>
    </template>

    <div class="card-header">
      <div class="card-header-wrapper">
        <div class="card-header-container">
          <div class="card-title font-medium">
            {{ $t('coursesDetail.highlights') }}
          </div>
          <div class="card-header-right clickable" @click="showDialog">
            <span class="btn-icon-to-detail highlights-icon"><i class="iconfont icon-reschedule icon-to-detail" /></span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <p v-for="(highlight, index) in highlightsFilterTitle" :key="index" class="tag-item font-medium">
        {{ highlight }}
      </p>
    </div>

    <ServiceHighlightsDialog ref="serviceHighlightsDialog" :highlights="highlights" />
  </div>
</template>

<script>
import ServiceHighlightsDialog from 'components/coursesDetail/ServiceHighlightsDialog'

export default {
  components: { ServiceHighlightsDialog },
  props: {
    highlights: {
      type: Array,
      default: () => ([]),
    },
    showDecoration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    highlightsFilterTitle() {
      if (!this.highlights) return ''
      const highlightList = []
      this.highlights.forEach((highlight) => {
        highlightList.push(highlight.title)
      })
      return highlightList
    },
  },
  methods: {
    showDialog() {
      this.$refs.serviceHighlightsDialog.showHighlightsDialog()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../card-section.scss';

.service-highlights {
  margin-top: 10px;

  .highlights-icon {
    // 扩大可点击区域
    margin-left: 30px;
  }

  .card-body {
    padding: 4px 8px;
  }

  .tag-item {
    flex-shrink: 0;
    margin: 8px;
  }
}
</style>
